
import React from 'react';
import { Button } from "@/components/ui/button";
import { Link } from 'react-router-dom';

interface AboutCTAProps {
  title?: string;
  description?: string;
  primaryButtonText?: string;
  primaryButtonLink?: string;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
}

const AboutCTA = ({
  title = "Lad os starte din musikalske rejse sammen",
  description = "Book en gratis prøvetime og lad os udforske hvordan jeg kan hjælpe dig med at nå dine mål ved klaveret.",
  primaryButtonText = "Book gratis prøvetime",
  primaryButtonLink = "/kontakt#top",
  secondaryButtonText = "Se undervisningstilbud",
  secondaryButtonLink = "/undervisning#top"
}: AboutCTAProps) => {
  return (
    <section className="py-16 bg-piano-black text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-serif font-bold mb-6">{title}</h2>
        <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
          {description}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild size="lg" className="bg-piano-gold hover:bg-piano-gold/90 text-white">
            <Link to={primaryButtonLink} onClick={() => window.scrollTo(0, 0)}>{primaryButtonText}</Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="bg-white border-white text-piano-black hover:bg-white/90">
            <Link to={secondaryButtonLink} onClick={() => window.scrollTo(0, 0)}>{secondaryButtonText}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default React.memo(AboutCTA);
